var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4748 16.2118C17.85 15.5869 16.8369 15.5869 16.2121 16.2118C15.5872 16.8366 15.5872 17.8497 16.2121 18.4745L20.7375 23L16.2121 27.5255C15.5872 28.1503 15.5872 29.1634 16.2121 29.7882C16.8369 30.4131 17.85 30.4131 18.4748 29.7882L23.0003 25.2627L27.5258 29.7882C28.1506 30.4131 29.1637 30.4131 29.7885 29.7882C30.4133 29.1634 30.4133 28.1503 29.7885 27.5255L25.263 23L29.7885 18.4745C30.4133 17.8497 30.4133 16.8366 29.7885 16.2118C29.1637 15.5869 28.1506 15.5869 27.5258 16.2118L23.0003 20.7373L18.4748 16.2118Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-icon.e6bb1ae0be376461ef1405193fff5110.svg";